import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    position: 'relative',
    padding: theme.spacing(4),
  },

  redCorner: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: 'auto',
  },

  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },

  empty: {
    gap: theme.spacing(10),
  },

  withContent: {
    gap: theme.spacing(6),
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    color: theme.palette.text.primary,
    width: 'max-content',
  },

  titleLink: {
    cursor: 'pointer',

    '&:hover': {
      background: `linear-gradient(98deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main} 100%)`,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',

      '& > svg': {
        color: theme.palette.primary.main,
      },
    },
  },

  titleIcon: {
    width: '1em',
    height: '1em',
    fontSize: 18,
  },
}));
